import { CREATE_CREDIT, ADD_ROUTE_CREDIT, EDIT_ROUTE_CREDIT, LIST_CREDIT, VIEW_CREDIT, ROUTES_LIST_CREDIT } from "./types";


export const createCreditAction = (data, onSuccess, onError) => {
    return {
        type: CREATE_CREDIT,
        data,
        onSuccess,
        onError,
    };
};

export const editRouteCreditAction = (data, onSuccess, onError) => {
    return {
        type: EDIT_ROUTE_CREDIT,
        data,
        onSuccess,
        onError,
    };
};

export const listCreditAction = (data, onSuccess, onError) => {
    return {
        type: LIST_CREDIT,
        data,
        onSuccess,
        onError,
    };
};

export const viewCreditAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_CREDIT,
        data,
        onSuccess,
        onError,
    };
};

export const routesListCreditAction = (data, onSuccess, onError) => {
    return {
        type: ROUTES_LIST_CREDIT,
        data,
        onSuccess,
        onError,
    };
};

export const addRouteCreditCreditAction = (data, onSuccess, onError) => {
    return {
        type: ADD_ROUTE_CREDIT,
        data,
        onSuccess,
        onError,
    };
};